export const on = (actionType, resolver) => (action, state) => actionType === action.type && resolver(action, state)

const createLocalStoreMiddleware = (resolvers) => (store) => (next) => (action) => {
  resolvers.forEach((resolver) => resolver(action, store.getState()))
  return next(action)
}

export default createLocalStoreMiddleware
